/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type SoftwareCodeEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const softwareCodeEntrypoint: EntryPoint<SoftwareCodeEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<SoftwareCodeEntrypointComponent>(
			/* webpackChunkName: "async-software-code-entrypoint" */ './CodeSpaV2.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
